/**
 * quantityBand.js — the client's copy of the gate's quantity verdict.
 *
 * The bands here MUST match services/stockInGate.js. This is the early word shown under
 * the quantity field while the user types; the gate is the enforcement. If the two drift,
 * the form starts either nagging about quantities that will be accepted or staying silent
 * about ones that will be rejected after the bill is finished — both of which teach the
 * user to ignore it.
 *
 * THE GATE NO LONGER JUDGES QUANTITY (17 Oct 2026), so this says nothing, ever.
 *
 * Its "usual" (`typicalQuantity`) was, for most businesses, the average LEFTOVER in a
 * batch — InventoryBatches.quantity shrinks as sales use it up — so an ordinary delivery
 * read as "20× more than usual" and was blocked. Buying more or less than last time is
 * normal; a mistyped quantity still shows up as a wrong unit price, which the gate and DSF
 * judge. See "4B.2" in services/stockInGate.js.
 *
 * @param {number} enteredQuantityInStandardUnit
 * @param {object} bench
 * @returns {null}
 */
// eslint-disable-next-line no-unused-vars
export const quantityBandVerdict = (enteredQuantityInStandardUnit, bench) => null;
